import React, {ReactNode} from 'react'
import {StyledDiv} from '../../../../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Box} from '@mui/material'
import {ApplyTitle, FirstPageDiv, HeaderArea, HeaderAreaBox, NextPageDiv} from './NatAdminApplicatioPrintCommonStyle'
import {RESIDENT_APPLY_PROCESS, RESIDENT_APPLY_STATUS} from '../../../../../../CodeMaster'
import {getPrintDate, getPrintTime} from '../../helper/NatApplicationHelper'
import {NatSealField, SealField} from './NatSealField'
import {convertToRoomNumberForResident, getFormattedZipCode} from '../../../../../common/util/Natutil'
import {ApplyStatusInfo} from '../../../repository/NatGetApplicationStatus'
import moment from 'moment'
import {NatEncloseInParenthesis} from './NatEncloseInParenthesis'
import {NatBrowseApplyDetail} from '../../../repository/NatGetBrowseApply'
import {Nullable} from '../../../../../../app/TypeHelpers'

interface Props {
    browseApplicationDocumentParam: NatBrowseApplyDetail
    applyStatusInfoList: ApplyStatusInfo[]
}

export const NatBrowseApplicationDocument: React.FC<Props> = props => {
    const {
        browseApplicationDocumentParam,
        applyStatusInfoList
    } = props

    const {
        applyId,
        condominiumName,
        ridgeName,
        roomNumber,
        applicantFamilyName,
        applicantFirstName,
        browseReasonDetail,
        videoRecordingPlace,
        videoRecordingDate,
        videoRecordingStartTime,
        videoRecordingEndTime,
        browsePreferredDate,
        browsePreferredStartTime,
        browsePreferredEndTime,
        accompany,
        note,
    } = browseApplicationDocumentParam

    const applicantRoom = `${ridgeName} ${convertToRoomNumberForResident(roomNumber)}`
    const applicantName = `${applicantFamilyName} ${applicantFirstName}`

    return (<>
        <FirstPageDiv>
            <HeaderArea>
                <HeaderAreaBox>
                    <Box ml={'auto'} mt={'10mm'}>申請ID：{applyId}</Box>
                </HeaderAreaBox>
                <HeaderAreaBox>
                    <Box m={'auto'}><ApplyTitle>閲覧申請書</ApplyTitle></Box>
                </HeaderAreaBox>
                <HeaderAreaBox>
                    <Box ml={'auto'} mt={'3mm'}>
                        {renderSealField(applyStatusInfoList)}
                    </Box>
                </HeaderAreaBox>
            </HeaderArea>
            <Box ml={'25mm'} mt={'3mm'}>
                理事長殿
            </Box>
            <Box ml={'30mm'} mt={'5mm'} whiteSpace={'pre-wrap'}>
                　私は、防犯カメラ運用規則を遵守することを誓約し、次の通り閲覧許可の申請をいたします。
            </Box>
            <Box margin={'3mm 0 0 30mm'} display={'flex'} flexDirection={'column'} width={'130mm'}>
                <Box>
                    <Box mb={'5mm'} whiteSpace={'pre-wrap'}>1  申請者</Box>
                    <Box ml={'8mm'} mb={'5mm'}>
                        {renderApplicationDetail('マンション名', condominiumName)}
                        {renderApplicationDetail('部屋番号', applicantRoom)}
                        {renderApplicationDetail('氏名', applicantName)}
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'}>
                        <Box mb={'5mm'} whiteSpace={'pre-wrap'}>2  閲覧理由</Box>
                    </Box>
                    <Box ml={'5mm'} mb={'5mm'}>
                        <StyledCardContent>
                            {browseReasonDetail}
                        </StyledCardContent>
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'} whiteSpace={'pre-wrap'}>
                        3  閲覧したい録画映像
                    </Box>
                    <Box ml={'8mm'} mb={'5mm'}>
                        {renderApplicationDetail('場所', videoRecordingPlace)}
                        {renderApplicationDetail('日付', renderBrowseApplyDate(videoRecordingDate))}
                        {renderApplicationDetail('開始時間',
                            renderBrowseApplyTime(videoRecordingDate, videoRecordingStartTime))}
                        {renderApplicationDetail('終了時間',
                            renderBrowseApplyTime(videoRecordingDate, videoRecordingEndTime))}
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'} whiteSpace={'pre-wrap'}>
                        4  閲覧の希望日時
                    </Box>
                    <Box ml={'8mm'} mb={'5mm'}>
                        {renderApplicationDetail('日付', renderBrowseApplyDate(browsePreferredDate))}
                        {renderApplicationDetail('開始時間',
                            renderBrowseApplyTime(browsePreferredDate, browsePreferredStartTime))}
                        {renderApplicationDetail('終了時間',
                            renderBrowseApplyTime(browsePreferredDate, browsePreferredEndTime))}
                    </Box>
                </Box>
            </Box>
        </FirstPageDiv>
        <NextPageDiv>
            <HeaderArea>
                <HeaderAreaBox>
                    <Box ml={'auto'} mt={'10mm'}>申請ID：{applyId}</Box>
                </HeaderAreaBox>
                <HeaderAreaBox>
                    <Box m={'auto'}><ApplyTitle>閲覧申請書</ApplyTitle></Box>
                </HeaderAreaBox>
            </HeaderArea>
            <Box margin={'3mm 0 0 30mm'} display={'flex'} flexDirection={'column'} width={'130mm'}>
                <Box>
                    {(accompany && accompany.length > 0) ?
                        <>
                            <Box mb={'5mm'} whiteSpace={'pre-wrap'}>5  同行者</Box>
                            {accompany.map((recode, key) =>
                                <Box ml={'8mm'} mb={'5mm'} key={key}>
                                    {renderApplicationDetail('同行者名', recode.accompanyName)}
                                    {renderApplicationDetail('続柄', recode.relationship)}
                                    {renderApplicationDetail('郵便番号', getFormattedZipCode(recode.zipCode ?? '', false))}
                                    {renderApplicationDetail('都道府県', recode.prefecture)}
                                    {renderApplicationDetail('市区町村', recode.address2)}
                                    {renderApplicationDetail('番地', recode.address3)}
                                    {renderApplicationDetail('建物名・部屋番号', recode.buildingRoomNumber)}
                                </Box>
                            )}
                        </> :
                        <>
                            <Box mb={'5mm'}>
                                {renderApplicationDetail('５ 同行者', 'なし')}
                            </Box>
                        </>
                    }
                </Box>
                <Box>
                    <Box mb={'5mm'}>
                        <Box mb={'5mm'} whiteSpace={'pre-wrap'}>6  備考</Box>
                    </Box>
                    <Box ml={'5mm'} mb={'5mm'}>
                        <StyledCardContent>
                            {note}
                        </StyledCardContent>
                    </Box>
                </Box>
            </Box>
        </NextPageDiv>
    </>)

}
NatBrowseApplicationDocument.displayName = 'NatBrowseApplicationDocument'

const renderApplicationDetail = (title: string, value: Nullable<string | ReactNode>) => {
    return (
        <PrintApplicationDetailContainer>
            <Box whiteSpace={'pre-wrap'}>{title}</Box>
            <NatEncloseInParenthesis item={value ?? ''}/>
        </PrintApplicationDetailContainer>
    )
}

const renderBrowseApplyDate = (date: string) => {
    const value = getPrintDate(date)

    return (
        <>
            <Box component={'span'} paddingRight={'3mm'} textAlign={'right'} width={'12mm'}>{value.year}</Box>年
            <Box component={'span'} paddingRight={'3mm'} textAlign={'right'} width={'11mm'}>{value.month}</Box>月
            <Box component={'span'} paddingRight={'3mm'} textAlign={'right'} width={'11mm'}>{value.day}</Box>日
        </>
    )
}

const renderBrowseApplyTime = (date: string, time: string) => {
    const value = getPrintTime(date, time)

    return (
        <>
            <Box component={'span'} paddingRight={'3mm'} textAlign={'right'} width={'12mm'}>{value.hours}</Box>時
            <Box component={'span'} paddingRight={'3mm'} textAlign={'right'} width={'11mm'}>{value.minutes}</Box>分
        </>
    )
}

const renderSealField = (applyStatusInfoList: ApplyStatusInfo[]) => {
    const sealFields: SealField[] = applyStatusInfoList.map((info) => {
        const applyStatusEnum = RESIDENT_APPLY_PROCESS.codeToEnumConstants(info.applyProcess)
        let seal
        if (info.applyStatus === RESIDENT_APPLY_STATUS.REJECTION.value) {
            seal = '却下'
        } else {
            seal = info.actual.registerDatetime ? moment(info.actual.registerDatetime).format('YYYY/M/D') : ''
        }
        return {
            applyStatus: applyStatusEnum.label,
            seal: seal,
            sortOrder: applyStatusEnum.displayOrder
        }
    })

    return (
        <NatSealField sealFields={sealFields}/>
    )
}

const PrintApplicationDetailContainer: StyledDiv = styled.div`
  display: flex;
  width: 100%;
`

const StyledCardContent = styled.div`
  border: solid 0.5pt black;
  width: 135mm;
  min-height: 25mm;
  height: 100%;
  white-space: pre-wrap;
  padding: 1mm 1mm 5mm 1mm;
`
